import React from "react";
import deleteIcon from "../../assets/deleteIcon.png";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../state/configureStore";


export const Tag = ({ text, colorCode, backgroundColor, onDelete, colorCodeCircle }
  : { text: string, colorCode: string, colorCodeCircle?: boolean, backgroundColor?: boolean, onDelete?: (tag: string) => void }) => {

  const isTablet = useSelector<RootState>(state => state.dimensions.device) === "tablet"
  const isMobile = useSelector<RootState>(state => state.dimensions.device) === "mobile"


  return (
    <Box>
      <Box style={{
        display: "flex",
        gap: 8,

        alignItems: "center",
        backgroundColor: backgroundColor ? colorCode : "transparent",
        padding: "2px 10px",
        borderRadius: "50px",
        fontSize: "14px"
      }}>
        {colorCodeCircle && (
          <Box style={{ width: "14px" }}>
            <div style={{ width: "14px", height: "14px", backgroundColor: colorCode, borderRadius: "50%" }}>
            </div>
          </Box>
        )}

        <Typography style={{
          maxWidth: isMobile ? "100px" : isTablet ? "120px" : "320px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }} fontSize={14}>{text}</Typography>

        {onDelete && (
          <img
            src={deleteIcon}
            alt="remove"
            style={{ width: 14, height: 14, cursor: "pointer" }}
            onClick={() => onDelete(text)}
          />
        )}
      </Box>
    </Box>
  )
}